export const content = {
  fontFamily: "Inter",
};
